import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { get } from 'lodash';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { deserialize, dataMember, required } from 'santee-dcts';
import { Settings } from '../../core';
import { CategoryNaturalKey } from '../../documents';

@Injectable()
export class StandardTitlesStorage {
    private readonly titlesByCategoryId: Observable<StandardTitlesByCategoryId>;

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) {
        this.titlesByCategoryId = this.loadAll()
            .pipe(
                publishLast(),
                refCount()
            );
    }

    public getStandardTitles(categoryId: CategoryNaturalKey): Observable<string[]> {
        return this.titlesByCategoryId.pipe(map(
            titles => get(titles, categoryId, [])
        ));
    }

    private loadAll(): Observable<StandardTitlesByCategoryId> {
        return this.http.get(`${this.settings.apiUrl}/admin/documents/standard-titles`)
            .pipe(map(rawData => deserialize(rawData, StandardTitleReadModel).standardTitlesByCategoryId));
    }
}

type StandardTitlesByCategoryId = {
    [key in CategoryNaturalKey]?: string[];
};

class StandardTitleReadModel {
    @dataMember()
    @required()
    public standardTitlesByCategoryId: StandardTitlesByCategoryId;
}